import { EntityId } from "@jackfruit/common"
import { useSelector } from "react-redux"
import { vnzImagesSelectors } from "~/redux/state/VNZImages"
import { RootState } from "~/redux/store"

export const useVNZImage = (id: EntityId) => {
  const vnzImage = useSelector((state: RootState) =>
    vnzImagesSelectors.selectById(state, id)
  )

  return { vnzImage }
}
